function isNotEmptyString (val) {
  return typeof val === 'string' && val !== ''
}
export function getCookie (name) {
  let ret
  let m
  if (isNotEmptyString(name)) {
    if ((m = String(document.cookie).match(
      new RegExp('(?:^| )' + name + '(?:(?:=([^;]*))|;|$)')))) {
      ret = m[1] ? decodeURIComponent(m[1]) : ''
    }
  }
  return ret
}
export function setCookie (name, val, expires, domain, path, secure) {
  let text = String(encodeURIComponent(val))
  let date = expires
  // 从当前时间开始，多少天后过期
  if (typeof date === 'number') {
    date = new Date()
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000)
  }
  // expiration date
  if (date instanceof Date) {
    text += '; expires=' + date.toUTCString()
  }
  // domain
  if (isNotEmptyString(domain)) {
    text += '; domain=' + domain
  }
  // path
  if (isNotEmptyString(path)) {
    text += '; path=' + path
  }
  // secure
  if (secure) {
    text += '; secure'
  }
  document.cookie = `"${name}=${text}"`
}
export function removeCookie (name, domain, path, secure) {
  setCookie(name, '', -1, domain, path, secure)
}



// WEBPACK FOOTER //
// ./src/api/js/cookie.js